import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { getPolicyDetail } from "../../store/actions/councilActions/policyAction";
import BreadCrumb from "../BreadCrumb";
import "./policy.css";

// Website: one policy's full detail, opened from the policies page.
export default function PolicyDetail() {
  const dispatch = useDispatch();
  const { slug } = useParams();
  const [policy, setPolicy] = useState(undefined); // undefined = loading

  useEffect(() => {
    setPolicy(undefined);
    dispatch(getPolicyDetail(slug)).then((p) => setPolicy(p || null));
  }, [dispatch, slug]);

  const breadcrumbs = [
    { path: "/", label: "Home" },
    { path: "/policies", label: "Policies" },
    { label: policy?.title || "Policy" },
  ];

  return (
    <div class="lists-box">
      <div class="container">
        <BreadCrumb crumbs={breadcrumbs} />

        {policy === undefined ? (
          <div class="text-center my-5">
            <Spinner animation="border" />
          </div>
        ) : policy === null ? (
          <div class="my-5 text-center">
            <p>This policy was not found.</p>
            <Link class="btn btn-danger" to="/policies">
              Back to Policies
            </Link>
          </div>
        ) : (
          <div class="policy-detail">
            <div class="title-box">
              <h4>{policy.title}</h4>
            </div>
            {policy.trade?.name && (
              <div class="policy-trade-tag">{policy.trade.name}</div>
            )}
            <div
              class="policy-content"
              dangerouslySetInnerHTML={{ __html: policy.content }}
            />
          </div>
        )}
      </div>
    </div>
  );
}
